import React, {useEffect, useState} from "react";
import {Patient} from "../../../../Types";
import {Card, Flex, Text} from "rebass";
import {CardHeader} from "../../../../Components";

function randInt(max) {
  return Math.floor(Math.random() * max);
}

const points: any[] = []
const fetchData = async () => {

  await setTimeout(function(){}, 2000);

  const lastPoint = points[points.length - 1]
  let nextPoint;

  if (lastPoint && lastPoint.value < 100 && lastPoint.value/100 < Math.random()) {
    lastPoint.value = Math.min((lastPoint.value + randInt(30)), 100)
    nextPoint = lastPoint
  } else {
    while (true) {
      nextPoint = {x: 2 + randInt(7), y: 2 + randInt(7), value: 0}
      if (points.every(point => point.x !== nextPoint.x || point.y !== nextPoint.y)) {
        points.push(nextPoint)
        break
      }

      points.pop()
    }

  }

  return {nextPoint: nextPoint, lastPoints: points.slice(0, points.length - 1)}

}

export const PerimetryTest: React.FC<{
  patient: Patient;
}> = ({patient}) => {

  const [loadingPoint, setLoadingPoint] = useState<any>()
  const [loadedPoints, setLoadedPoints] = useState<any[]>([])


  useEffect(() => {
    const interval = setInterval(() => {
      fetchData().then(
        (result) => {
          setLoadingPoint(result.nextPoint)
          setLoadedPoints(result.lastPoints)
        }
      )
    }, 1000);
    return () => clearInterval(interval);
  }, []);


  return (
    <Card paddingBottom={"32px"}>
      <CardHeader headerText="Visual Field Perimetry Test"/>

      <Flex justifyContent="space-evenly">
        <EyeGraph size={600} title="Left Eye" loadingPoint={loadingPoint} loadedPoints={loadedPoints}/>
        <EyeGraph size={600} title="Right Eye" loadingPoint={undefined} loadedPoints={[]}/>
      </Flex>

    </Card>
    )
}

export const EyeGraph: React.FC<{
  size: number;
  title: string;
  loadingPoint: any;
  loadedPoints: any[];
}> = ({size, title, loadingPoint, loadedPoints}) => {
  console.log(loadingPoint, loadedPoints)
  return (
    <svg
      width={size}
      height={size}
      viewBox={"-2.5 -2.5 " + (size + 5) + " " + (size + 5)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >

      {Array.from(Array(10).keys()).map(i => (i !== 5 && i !== 0)? <>
        <line x1={i * size/10} y1={0} x2={i * size/10} y2={size} stroke="#dddddf" strokeLinecap="round" key={title + i + "x"}/>
        <line y1={i * size/10} x1={0} y2={i * size/10} x2={size} stroke="#dddddf" strokeLinecap="round" key={title + i + "y"}/>
      </>:undefined)}

      <line x1="0" y1={size/2} x2={size} y2={size/2} stroke="#2D3F47" strokeLinecap="round"/>
      <line y1="0" x1={size/2} y2={size} x2={size/2} stroke="#2D3F47" strokeLinecap="round"/>

      {loadedPoints.map(loadedPoint =>
        <Datapoint x={loadedPoint.x/10 * size} y={loadedPoint.y/10 * size}
                   radius={1/40 * size} value={loadedPoint.value} key={title + loadedPoint.x + loadedPoint.y}/>
      )}

      {loadingPoint? <LoadingDatapoint x={loadingPoint.x/10 * size} y={loadingPoint.y/10 * size} radius={1/40 * size} targetValue={loadingPoint.value} speed={0.01}/>:undefined}

      <circle r={3/4 * size} cx={size/2} cy={size/2} fill="none" strokeWidth={size/2} stroke="white"/>
      <circle r={size/2} cx={size/2} cy={size/2} fill="none" stroke="#dddddf"/>

    </svg>
  )
}

export const Datapoint: React.FC<{
  x: number;
  y: number;
  radius: number;
  value: number; // 0 to 1
}> = ({x, y, radius, value}) => {
  const color = "hsl(199, 48%, " + (48 - 28 * value/100) + "%)"

  return (
    <>
      <circle r={radius} cx={x} cy={y} fill={color}/>
      <text x={x} y={y + 1} dominantBaseline="middle" textAnchor="middle" stroke="#F4F9FF">{value}</text>
    </>
  )
}

export const LoadingDatapoint: React.FC<{
  x: number;
  y: number;
  radius: number;
  targetValue: number;
  speed: number; // 0 to 1
}> = ({x, y, radius, targetValue, speed}) => {
  // 0 to 1
  const [percent, setPercent] = useState(0)
  const stepsPerSecond = 100

  const targetPercent = targetValue/100

  if (targetPercent < percent) setPercent(targetPercent)


  useEffect(() => {
    const interval = setInterval(() => {
      setPercent(percent + (targetPercent-percent) * speed)
    }, 1000/stepsPerSecond);
    return () => clearInterval(interval);
  }, [percent, targetPercent]);


  const angle = 360 * percent
  const color = "hsl(199, 48%, " + (48 - 28 * percent) + "%)"

  return <path d={describeArc(x, y, radius, 0, angle) + "L" + x + " " + y + " Z"} fill={color}/>
}

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;

  return {
    x: centerX + (radius * Math.cos(angleInRadians)),
    y: centerY + (radius * Math.sin(angleInRadians))
  };
}

function describeArc(x, y, radius, startAngle, endAngle){

  var start = polarToCartesian(x, y, radius, endAngle);
  var end = polarToCartesian(x, y, radius, startAngle);

  var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

  var d = [
    "M", start.x, start.y,
    "A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
  ].join(" ");

  return d;
}
